//@flow
import React from 'react'
import { useTranslation } from 'react-i18next'
import { WebcamButton } from '@bfg/components/utils/WebcamButton'
import { useSteps } from '@bfg/effects/steps'

export const BtnListDesktop = (props: any) => {
  const { t } = useTranslation()
  const stepsHandler = useSteps()
  // console.log(stepsHandler, 'stepsHandler')
  return (
    <div className="btn-list desktop">
      <div className="single-btn-box">
        <WebcamButton parent={props.parent} isMobile={false} subscriberId={props.subscriberId}/>
      </div>
      {/*<div className="single-btn-box">*/}
      {/*  <a*/}
      {/*    href="#choose-celebrity-form"*/}
      {/*    className="btn popup-with-form"*/}
      {/*    title={t('parent.buttons.Choose a celebrity')}*/}
      {/*    onClick={props.openPopup}*/}
      {/*  >*/}
      {/*    <span className="bm_icon_user"/>{t('parent.buttons.Choose a celebrity')}*/}
      {/*  </a>*/}
      {/*</div>*/}
      <div className="single-btn-box full-width">
        <a href="#" onClick={props.handleClickNext} className={`btn ${stepsHandler.nextAvailable ? `green` : `dark`}`}
           title={t(`steps.mobile.${stepsHandler.currentStep.mobileName}`)}>
          {t(`steps.mobile.${stepsHandler.currentStep.mobileName}`)}
        </a>
      </div>
    </div>
  )
}

export const BtnListMobile = (props: any) => {
  const { t } = useTranslation()
  const iOS = () => (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
  return (
    <div className="btn-list mobile">
      {!iOS() &&
        <div className="single-btn-box">
          <WebcamButton parent={props.parent} isMobile={true} subscriberId={props.subscriberId}/>
        </div>
      }
      {/*<div className={`single-btn-box ${iOS() ? 'full-width' : ''}`}>*/}
      {/*  <a*/}
      {/*    href="#choose-celebrity-form"*/}
      {/*    className="btn popup-with-form"*/}
      {/*    title={`...${t('parent.buttons.OR CHOOSE A CELEBRITY')}`}*/}
      {/*    onClick={props.openPopup}*/}
      {/*  >{`...${t('parent.buttons.OR CHOOSE A CELEBRITY')}`}</a>*/}
      {/*</div>*/}
    </div>
  )
}

export const BtnListMobileNew = (props: any) => {
  const openPopup = (e) => {
    e.preventDefault()
    props.openPopup()
  }

  const { t } = useTranslation()
  const iOS = () => (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
  return (
    <div className="btn-list mobile new">
      {!iOS() &&
        <div className="single-btn-box new full-width">
          <WebcamButton parent={props.parent} isMobile={true} subscriberId={props.subscriberId}/>
        </div>
      }
      <div className={`single-btn-box new ${iOS() ? 'full-width' : ''}`}>
        <a
          href="#choose-celebrity-form"
          className="btn celeb-use popup-with-form"
          title={`...${t('parent.buttons.OR CHOOSE A CELEBRITY')}`}
          onClick={openPopup}
        >{`...${t('parent.buttons.OR CHOOSE A CELEBRITY')}`}</a>
      </div>
    </div>
  )
}
